let defaultFile = {
  name: '',
  ext: '',
  data: null,
  isReady: false,
  error: null,

  isUploading: false,
  isUploaded: false,

  uploadId: null
};

interface SelectFile {
  type: 'SELECT_FILE';
  data: {
    name: string;
    ext: string;
    data: any;
  };
}

interface UploadFile {
  type: 'UPLOAD_FILE';
  data: any;
}

interface FileIsUploaded {
  type: 'FILE_IS_UPLOADED';
  data: any;
}

interface SetFileReady {
  type: 'SET_FILE_READY';
  data: {
    isReady: boolean;
  };
}

interface SetFileError {
  type: 'SET_FILE_ERROR';
  data: {
    error: boolean;
  };
}

type FileAction =
  | SelectFile
  | UploadFile
  | FileIsUploaded
  | SetFileReady
  | SetFileError;

export default function fileReducer(state = null, action: FileAction) {
  let { type, data } = action;

  switch (type) {
    case 'SELECT_FILE':
      let file = Object.assign({}, defaultFile, {
        name: data.name,
        ext: data.ext,
        data: data.data
      });

      return Object.assign({}, state, file);

    case 'UPLOAD_FILE':
      return Object.assign({}, state, {
        isUploading: true,
        isUploaded: false
      });

    case 'FILE_IS_UPLOADED':
      return Object.assign({}, state, {
        isUploading: false,
        isUploaded: true,
        uploadId: data
      });

    // Simple property changes
    case 'SET_FILE_READY':
      return Object.assign({}, state, {
        isReady: data.isReady,
        error: null
      });

    case 'SET_FILE_ERROR':
      return Object.assign({}, state, {
        error: data.error,
        isReady: false
      });

    default:
      return state;
  }
}
